import React from 'react';
import { StyleSheet, View } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';


const Fondo = () => {

  return (
    <>
      <LinearGradient
        colors={['#fff', '#fff', '#fff']}
        style={styles.background}
      />
    </>
  );
}


export default Fondo

const styles = StyleSheet.create({

  background: {
    position: 'fixed',
    left: 0,
    right: 0,
    top: 0,
    height: "100%",
    zIndex: -1
  },


});


